import { Action } from '@ngrx/store';
import { GO_POST_PROCESS_LOGIN } from '../action-types';

export class PostProcessSSOLoginAction implements Action {
    readonly type = GO_POST_PROCESS_LOGIN;

    constructor(
        public payload: {
            userId: string;
            redirectUri?: string;
        }
    ) {}
}
